import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/home',
      component: () => import('@/components/Layout/Layout'),
      children: [
        {
          path: 'home',
          name: 'Home',
          component: () => import('@/views/Home/home'),
          meta: {
            keep: true,
            title: '达州市高新区能源信息大数据平台'
          }
        },
        {
          path: 'park',
          name: 'Park',
          component: () => import('@/views/Setting/ParkData'),
          meta: {
            title: '达州市高新区园区数据管理'
          }
        },
        {
          path: 'agency',
          name: 'AgencyList',
          component: () => import('@/views/Setting/agencyList'),
          meta: {
            title: '达州市高新区企业数据管理'
          }
        }
      ]
    },
    {
      path: '/info',
      redirect: '/info/structure',
      component: () => import('@/views/Info/Layout'),
      children: [
        {
          path: 'structure',
          name: 'InfoStructure',
          component: () => import('@/views/Info/structure'),
          meta: {
            keep: true,
            title: '达州市高新区节能标准信息网'
          }
        },
        {
          path: 'see/:sup/:child',
          name: 'InfoSee',
          component: () => import('@/views/Info/see'),
          props: true,
          meta: {
            keep: true,
            title: '达州市高新区节能标准信息网'
          }
        },
        {
          path: 'see/:sup/:child/:thr',
          name: 'InfoSee',
          component: () => import('@/views/Info/see'),
          props: true,
          meta: {
            keep: true,
            title: '达州市高新区节能标准信息网'
          }
        },
        {
          path: 'see',
          name: 'InfoAllSee',
          component: () => import('@/views/Info/see'),
          props: true,
          meta: {
            keep: true,
            title: '达州市高新区节能标准信息网'
          }
        }
      ]
    },
    {
      path: '/edit',
      component: () => import('@/views/Info/edit/Layout'),
      meta: {
        title: '达州市高新区节能标准信息网-添加'
      },
      children: [
        {
          path: 'add/:child',
          name: 'InfoAdd',
          component: () => import('@/views/Info/edit/add'),
          props: true,
          meta: {
            keep: true,
            title: '达州市高新区节能标准信息网-添加'
          }
        }
      ]
    }
  ]
})
